"use client";

import React from "react";
import { Landmark, BookOpen, ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
export default function DarkHeroBreadcrumbs() {
  return <section id="darkherobreadcrumbs" className="zona-pp-hero bg-[var(--pp-black)] w-full py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="space-y-6">
          <Breadcrumb>
            <BreadcrumbList className="text-gray-300 sm:gap-2 text-sm md:text-base">
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/PPZonePage" className="hover:text-white transition-colors">
                    Beranda Zona PP
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator className="text-gray-400" />
              <BreadcrumbItem>
                <BreadcrumbPage className="text-white font-medium">
                  Badan, Lembaga & Sayap
                  <h1 className="sr-only">Badan, Lembaga & Sayap Pemuda Pancasila</h1>
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>

          <Collapsible defaultOpen className="w-full">
            <div className="flex items-center justify-between md:block">
              <p className="text-gray-200 text-lg md:text-xl leading-relaxed max-w-2xl">
                Mengenal berbagai badan, lembaga, dan sayap organisasi di bawah
                naungan Pemuda Pancasila tingkat nasional hingga wilayah berdasarkan
                data resmi dan terverifikasi.
              </p>
              <CollapsibleTrigger asChild className="md:hidden">
                <Button variant="ghost" size="sm" className="text-white hover:bg-white/10">
                  <ChevronDown className="size-5" />
                </Button>
              </CollapsibleTrigger>
            </div>

            <CollapsibleContent className="mt-8 space-y-4 md:block">
              <div className="flex flex-wrap items-center gap-4">
                <Button size="lg" className="bg-[var(--pp-red)] hover:bg-[var(--pp-red)]/90 text-white border-none rounded-md px-6 h-12 text-base font-semibold shadow-md transition-all">
                  <Landmark className="mr-2 size-5" />
                  Nasional
                </Button>
                <Button size="lg" variant="outline" className="bg-white text-black hover:bg-gray-100 border-none rounded-md px-6 h-12 text-base font-semibold shadow-md transition-all">
                  <BookOpen className="mr-2 size-5" />
                  Direktori Wilayah
                </Button>
              </div>
            </CollapsibleContent>
          </Collapsible>
        </div>
      </div>
    </section>;
}